import {
  Text,
  VStack,
  Button,
  CloseIcon,
} from "native-base";
import "react-vertical-timeline-component/style.min.css";
import { useNavigate } from "react-router-dom";
import StyledImage from "../../components/Image";
import StyledButton from "../../components/Button";

function PinkHistory() {
  const HistoryImg = require("./history.png");

  const navigate = useNavigate();

  return (
    <div style={{background:'#F2E6BC'}}>
          <VStack
            alignItems="flex-start"
            space={0}
            px={"4"}
            paddingTop={"4"}
            marginBottom={"2"}
            background={"#F2E6BC"}
          >
            <Button onPress={() => navigate(-1)} variant={"unstyled"}>
              <CloseIcon color={"#B03D01"} size={"4"} />
            </Button>
          </VStack>
         
          <VStack
              alignItems={"center"}
              marginBottom={"4"}
              px={4}
              space={"6"}
          >
                <Text
                  color={'black'}
                  fontFamily={'Unna'} 
                  fontSize={'32px'}
                  letterSpacing={"0.46px"}
                >
                 History & Inspiration
                </Text>
                <Text
                  fontFamily={'Unna'} 
                  fontSize={'12px'}
                  letterSpacing={"0.46px"}
                  
                >
                 FABRIC IN USE SINCE ABOUT 1911
                </Text>
          </VStack>

          <VStack
              marginTop={10}
              marginLeft={5}
              marginRight={5}
              px={4}
          >
                <Text
                 color={'#9D7C07'}
                 fontFamily={'Unna'} 
                  fontSize={'15px'}
                  letterSpacing={"0.46px"}
                >
                 KEEPING A BEAUTIFUL FABRIC IN USE
                </Text>
                <Text
                  fontFamily={'Unna'} 
                  fontSize={'12px'}
                  letterSpacing={"0.6px"}
                  marginTop={2}
                >
                In raiding our mother’s linen closets and inheriting dining gems, we found there was so much beautiful fabric to revive into special new garments for women.  Most of our fabrics come from our great grandmothers or grandmothers that have luckily been saved through the generations to transform into garments.
                </Text>
                <Text
                 fontFamily={'Unna'} 
                  fontSize={'12px'}
                  letterSpacing={"0.6px"}
                  marginTop={4}
                >
                We only produce with what fabric is available to us, so we only create limited quantities, or only one, making you the one lucky owner of this garment.
                </Text>
          </VStack>
          <VStack
              marginTop={10}
              marginLeft={5}
              marginRight={5}
              px={4}
          >
                <Text
                 color={'#9D7C07'}
                 fontFamily={'Unna'} 
                  fontSize={'15px'}
                  letterSpacing={"0.46px"}
                >
                 INSPIRATION
                </Text>
                <Text
                  fontFamily={'Unna'} 
                  fontSize={'12px'}
                  letterSpacing={"0.6px"}
                  marginTop={2}
                >
                When seeing this pink crochet fabric, we were immediately reminded of the 1960s new wave of ‘mod’ dressing in crochet tops and dresses, something like Twiggy. Keeping this in mind, while adding an updated look with jeweled buttons, ready for summer by the water, or over a white blouse ready to update your office look.</Text>
                
          </VStack>
          <VStack alignItems={"center"} marginBottom={5} marginTop={10}>
              <StyledImage
                width="60%"
                src={HistoryImg}
                alt={"Image of the product design 2"}
              />
            </VStack>
            
            <VStack alignItems={"center"} marginBottom={5} marginTop={10} marginLeft={4} marginRight={4}>
            <StyledButton
            fontFamily={'Unna'} 
            fontSize={'20px'}
              text={'LEARN MORE'}
              backgroundColor={'#EEA3AC'}
              textColor="black"
              borderColor="transparent"
              width="100%"
              height="54px"
              hoverBackgroundColor="#FFFFFF"
              hoverTextColor={'black'}
              hoverBorderColor={'black'}
            />
            </VStack>
        </div>
  );
}

export default PinkHistory;
